import {
  AccountInfo,
  AuthError,
  IPublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";

const logoutOnAuthErrors = [
  "invalid_grant",
  "interaction_required",
  "no_tokens_found",
];

const scopes = [`${import.meta.env.VITE_AGENTX_AUTH_APP_URI}/openid`];

export const getMsalAuthToken = async (
  msalAccount: AccountInfo | undefined,
  instance: IPublicClientApplication
): Promise<string | void> => {
  const request: RedirectRequest = {
    scopes: scopes,
    account: msalAccount,
  };

  try {
    if (msalAccount) {
      // This is to fix a render issue caused by instance.acquireTokenSilent
      // causing the MSAL provider to re-render
      // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/5796
      await Promise.resolve();
      const silentTokenResponse = await instance.acquireTokenSilent(request);

      if (!silentTokenResponse.account) {
        return await instance.acquireTokenRedirect(request);
      }
      return silentTokenResponse.accessToken;
    } else {
      return await instance.acquireTokenRedirect(request);
    }
  } catch (err: unknown) {
    if (
      err instanceof AuthError &&
      logoutOnAuthErrors.includes(err.errorCode)
    ) {
      await instance.logoutRedirect();
    } else {
      console.error(err);
    }
  }
};
